import { inventorySplitApi as api } from "./apiBase";
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        authControllerIssueToken: build.mutation<
            AuthControllerIssueTokenApiResponse,
            AuthControllerIssueTokenApiArg
        >({
            query: (queryArg) => ({
                url: `/auth/token`,
                method: "POST",
                headers: {
                    "X-Scanner-Access-Key-Id":
                        queryArg["X-Scanner-Access-Key-Id"],
                    "X-Scanner-Secret-Access-Key":
                        queryArg["X-Scanner-Secret-Access-Key"],
                    "X-Scanner-Session-Token":
                        queryArg["X-Scanner-Session-Token"],
                },
            }),
        }),
        configurationProfilesControllerRetrieveScannerProfiles: build.query<
            ConfigurationProfilesControllerRetrieveScannerProfilesApiResponse,
            ConfigurationProfilesControllerRetrieveScannerProfilesApiArg
        >({
            query: (queryArg) => ({
                url: `/config-profiles`,
                params: {
                    merchantId: queryArg.merchantId,
                    page: queryArg.page,
                },
            }),
        }),
        configurationProfilesControllerGetDefaultScannerProfile: build.query<
            ConfigurationProfilesControllerGetDefaultScannerProfileApiResponse,
            ConfigurationProfilesControllerGetDefaultScannerProfileApiArg
        >({
            query: (queryArg) => ({
                url: `/config-profiles/${queryArg.merchantId}/default`,
            }),
        }),
        configurationProfilesControllerRetrieveScannerProfile: build.query<
            ConfigurationProfilesControllerRetrieveScannerProfileApiResponse,
            ConfigurationProfilesControllerRetrieveScannerProfileApiArg
        >({
            query: (queryArg) => ({
                url: `/config-profiles/${queryArg.profileId}`,
            }),
        }),
        configurationProfilesControllerUpdateScannerProfile: build.mutation<
            ConfigurationProfilesControllerUpdateScannerProfileApiResponse,
            ConfigurationProfilesControllerUpdateScannerProfileApiArg
        >({
            query: (queryArg) => ({
                url: `/config-profiles/${queryArg.profileId}`,
                method: "PUT",
                body: queryArg.configurationProfileDto,
            }),
        }),
        configurationProfilesControllerDeleteScannerProfile: build.mutation<
            ConfigurationProfilesControllerDeleteScannerProfileApiResponse,
            ConfigurationProfilesControllerDeleteScannerProfileApiArg
        >({
            query: (queryArg) => ({
                url: `/config-profiles/${queryArg.profileId}`,
                method: "DELETE",
            }),
        }),
        configurationProfilesControllerUpdateScannerProfileAnalyticsTags:
            build.mutation<
                ConfigurationProfilesControllerUpdateScannerProfileAnalyticsTagsApiResponse,
                ConfigurationProfilesControllerUpdateScannerProfileAnalyticsTagsApiArg
            >({
                query: (queryArg) => ({
                    url: `/config-profiles/${queryArg.profileId}/analytics-tags`,
                    method: "PUT",
                    body: queryArg.body,
                }),
            }),
        configurationProfilesControllerUpdateScannerProfileFeatureOverrides:
            build.mutation<
                ConfigurationProfilesControllerUpdateScannerProfileFeatureOverridesApiResponse,
                ConfigurationProfilesControllerUpdateScannerProfileFeatureOverridesApiArg
            >({
                query: (queryArg) => ({
                    url: `/config-profiles/${queryArg.profileId}/features`,
                    method: "PUT",
                    body: queryArg.body,
                }),
            }),
        devicesControllerIotRegister: build.mutation<
            DevicesControllerIotRegisterApiResponse,
            DevicesControllerIotRegisterApiArg
        >({
            query: (queryArg) => ({
                url: `/scanners/${queryArg.deviceId}/iot-register`,
                method: "POST",
            }),
        }),
        devicesControllerQuickRegister: build.mutation<
            DevicesControllerQuickRegisterApiResponse,
            DevicesControllerQuickRegisterApiArg
        >({
            query: (queryArg) => ({
                url: `/scanners/${queryArg.deviceId}/quick-register`,
                method: "POST",
                params: {
                    certificateThumbprint: queryArg.certificateThumbprint,
                },
            }),
        }),
        scannersControllerUpdateScannerConfiguration: build.mutation<
            ScannersControllerUpdateScannerConfigurationApiResponse,
            ScannersControllerUpdateScannerConfigurationApiArg
        >({
            query: (queryArg) => ({
                url: `/scanners/${queryArg.deviceId}/configuration`,
                method: "PUT",
                body: queryArg.scannerSettingsDto,
            }),
        }),
        devicesControllerCreateAwsActivation: build.mutation<
            DevicesControllerCreateAwsActivationApiResponse,
            DevicesControllerCreateAwsActivationApiArg
        >({
            query: (queryArg) => ({
                url: `/scanners/${queryArg.deviceId}/reactivate`,
                method: "POST",
            }),
        }),
        devicesControllerConfirmAwsActivation: build.mutation<
            DevicesControllerConfirmAwsActivationApiResponse,
            DevicesControllerConfirmAwsActivationApiArg
        >({
            query: (queryArg) => ({
                url: `/scanners/${queryArg.deviceId}/confirm-activation`,
                method: "POST",
                params: {
                    activationId: queryArg.activationId,
                },
            }),
        }),
        devicesControllerUpdateDeviceConfiguration: build.mutation<
            DevicesControllerUpdateDeviceConfigurationApiResponse,
            DevicesControllerUpdateDeviceConfigurationApiArg
        >({
            query: (queryArg) => ({
                url: `/scanners/${queryArg.deviceId}/device-configuration`,
                method: "PUT",
                body: queryArg.updateDeviceConfigurationRequest,
            }),
        }),
        scannersControllerRetrieveDeviceConfiguration: build.query<
            ScannersControllerRetrieveDeviceConfigurationApiResponse,
            ScannersControllerRetrieveDeviceConfigurationApiArg
        >({
            query: (queryArg) => ({
                url: `/scanners/${queryArg.deviceId}/device-configuration`,
            }),
        }),
        scannersControllerRetrieveScanner: build.query<
            ScannersControllerRetrieveScannerApiResponse,
            ScannersControllerRetrieveScannerApiArg
        >({
            query: (queryArg) => ({ url: `/scanners/${queryArg.deviceId}` }),
        }),
        scannersControllerRetrieveScanners: build.query<
            ScannersControllerRetrieveScannersApiResponse,
            ScannersControllerRetrieveScannersApiArg
        >({
            query: (queryArg) => ({
                url: `/scanners`,
                params: {
                    PageNumber: queryArg.pageNumber,
                    PageSize: queryArg.pageSize,
                    DeviceId: queryArg.deviceId,
                    MerchantId: queryArg.merchantId,
                    ConfigurationProfileId: queryArg.configurationProfileId,
                    ScannerStatus: queryArg.scannerStatus,
                },
            }),
        }),
        scannersControllerImportScanners: build.mutation<
            ScannersControllerImportScannersApiResponse,
            ScannersControllerImportScannersApiArg
        >({
            query: (queryArg) => ({
                url: `/scanners`,
                method: "POST",
                body: queryArg.body,
            }),
        }),
        scannersControllerCreateLinkRequest: build.mutation<
            ScannersControllerCreateLinkRequestApiResponse,
            ScannersControllerCreateLinkRequestApiArg
        >({
            query: (queryArg) => ({
                url: `/scanners/link-requests`,
                method: "POST",
                params: {
                    region: queryArg.region,
                    merchantId: queryArg.merchantId,
                },
            }),
        }),
        scannersControllerRetrieveLinkRequest: build.query<
            ScannersControllerRetrieveLinkRequestApiResponse,
            ScannersControllerRetrieveLinkRequestApiArg
        >({
            query: (queryArg) => ({
                url: `/scanners/link-requests/${queryArg.merchantId}/${queryArg.code}`,
            }),
        }),
        scannersControllerUnlinkScanner: build.mutation<
            ScannersControllerUnlinkScannerApiResponse,
            ScannersControllerUnlinkScannerApiArg
        >({
            query: (queryArg) => ({
                url: `/scanners/${queryArg.deviceId}/unlink`,
                method: "POST",
            }),
        }),
        scannersControllerApproveQualityControl: build.mutation<
            ScannersControllerApproveQualityControlApiResponse,
            ScannersControllerApproveQualityControlApiArg
        >({
            query: (queryArg) => ({
                url: `/scanners/${queryArg.deviceId}/approve-qc`,
                method: "POST",
            }),
        }),
        scannersControllerDeclineQualityControl: build.mutation<
            ScannersControllerDeclineQualityControlApiResponse,
            ScannersControllerDeclineQualityControlApiArg
        >({
            query: (queryArg) => ({
                url: `/scanners/${queryArg.deviceId}/decline-qc`,
                method: "POST",
            }),
        }),
        scannersControllerCancelActivation: build.mutation<
            ScannersControllerCancelActivationApiResponse,
            ScannersControllerCancelActivationApiArg
        >({
            query: (queryArg) => ({
                url: `/scanners/${queryArg.deviceId}/cancel-activation`,
                method: "POST",
                params: {
                    activationId: queryArg.activationId,
                },
            }),
        }),
        scannersControllerCreateManualDeviceConfigurationAuditEntry:
            build.mutation<
                ScannersControllerCreateManualDeviceConfigurationAuditEntryApiResponse,
                ScannersControllerCreateManualDeviceConfigurationAuditEntryApiArg
            >({
                query: (queryArg) => ({
                    url: `/scanners/${queryArg.deviceId}/device-configuration/audit`,
                    method: "POST",
                    body: queryArg.createManualAuditEntryRequest,
                }),
            }),
        scannersControllerRetrieveDeviceConfigurationAudit: build.query<
            ScannersControllerRetrieveDeviceConfigurationAuditApiResponse,
            ScannersControllerRetrieveDeviceConfigurationAuditApiArg
        >({
            query: (queryArg) => ({
                url: `/scanners/${queryArg.deviceId}/device-configuration/audit`,
                params: {
                    eventTypes: queryArg.eventTypes,
                    pageNumber: queryArg.pageNumber,
                    pageSize: queryArg.pageSize,
                },
            }),
        }),
        scannersControllerCreateScannerDefect: build.mutation<
            ScannersControllerCreateScannerDefectApiResponse,
            ScannersControllerCreateScannerDefectApiArg
        >({
            query: (queryArg) => ({
                url: `/scanners/${queryArg.deviceId}/defects`,
                method: "POST",
                body: queryArg.createScannerDefectRequest,
            }),
        }),
        scannersControllerRetrieveScannerDefects: build.query<
            ScannersControllerRetrieveScannerDefectsApiResponse,
            ScannersControllerRetrieveScannerDefectsApiArg
        >({
            query: (queryArg) => ({
                url: `/scanners/${queryArg.deviceId}/defects`,
                params: {
                    status: queryArg.status,
                    pageNumber: queryArg.pageNumber,
                    pageSize: queryArg.pageSize,
                },
            }),
        }),
        scannersControllerCloseScannerDefect: build.mutation<
            ScannersControllerCloseScannerDefectApiResponse,
            ScannersControllerCloseScannerDefectApiArg
        >({
            query: (queryArg) => ({
                url: `/scanners/${queryArg.deviceId}/defects/${queryArg.defectId}/close`,
                method: "POST",
            }),
        }),
        scannersControllerReopenScannerDefect: build.mutation<
            ScannersControllerReopenScannerDefectApiResponse,
            ScannersControllerReopenScannerDefectApiArg
        >({
            query: (queryArg) => ({
                url: `/scanners/${queryArg.deviceId}/defects/${queryArg.defectId}/reopen`,
                method: "POST",
            }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as inventoryApi };
export type AuthControllerIssueTokenApiResponse =
    /** status 200 OK */ AccessTokenResponse;
export type AuthControllerIssueTokenApiArg = {
    "X-Scanner-Access-Key-Id"?: string;
    "X-Scanner-Secret-Access-Key"?: string;
    "X-Scanner-Session-Token"?: string;
};
export type ConfigurationProfilesControllerRetrieveScannerProfilesApiResponse =
    /** status 200 OK */ ConfigurationProfileDtoPagedList;
export type ConfigurationProfilesControllerRetrieveScannerProfilesApiArg = {
    merchantId?: number;
    page?: number;
};
export type ConfigurationProfilesControllerGetDefaultScannerProfileApiResponse =
    /** status 200 OK */ ConfigurationProfileDto;
export type ConfigurationProfilesControllerGetDefaultScannerProfileApiArg = {
    merchantId: number;
};
export type ConfigurationProfilesControllerRetrieveScannerProfileApiResponse =
    /** status 200 OK */ ConfigurationProfileDto;
export type ConfigurationProfilesControllerRetrieveScannerProfileApiArg = {
    profileId: number;
};
export type ConfigurationProfilesControllerUpdateScannerProfileApiResponse =
    /** status 200 OK */ ConfigurationProfileDto;
export type ConfigurationProfilesControllerUpdateScannerProfileApiArg = {
    profileId: number;
    configurationProfileDto: ConfigurationProfileDto;
};
export type ConfigurationProfilesControllerDeleteScannerProfileApiResponse =
    unknown;
export type ConfigurationProfilesControllerDeleteScannerProfileApiArg = {
    profileId: number;
};
export type ConfigurationProfilesControllerUpdateScannerProfileAnalyticsTagsApiResponse =
    /** status 200 OK */ ConfigurationProfileDto;
export type ConfigurationProfilesControllerUpdateScannerProfileAnalyticsTagsApiArg =
    {
        profileId: number;
        body: {
            [key: string]: string;
        };
    };
export type ConfigurationProfilesControllerUpdateScannerProfileFeatureOverridesApiResponse =
    unknown;
export type ConfigurationProfilesControllerUpdateScannerProfileFeatureOverridesApiArg =
    {
        profileId: number;
        body: {
            [key: string]: string;
        };
    };
export type DevicesControllerIotRegisterApiResponse =
    /** status 200 OK */ RegisterIotScannerResult;
export type DevicesControllerIotRegisterApiArg = {
    deviceId: string;
};
export type DevicesControllerQuickRegisterApiResponse =
    /** status 200 OK */ CredentialRegistrationResult;
export type DevicesControllerQuickRegisterApiArg = {
    deviceId: string;
    certificateThumbprint?: string;
};
export type ScannersControllerUpdateScannerConfigurationApiResponse =
    /** status 200 OK */ ScannerDto;
export type ScannersControllerUpdateScannerConfigurationApiArg = {
    deviceId: string;
    scannerSettingsDto: ScannerSettingsDto;
};
export type DevicesControllerCreateAwsActivationApiResponse =
    /** status 200 OK */ AwsActivationDetailsDto;
export type DevicesControllerCreateAwsActivationApiArg = {
    deviceId: string;
};
export type DevicesControllerConfirmAwsActivationApiResponse = unknown;
export type DevicesControllerConfirmAwsActivationApiArg = {
    deviceId: string;
    activationId?: string;
};
export type DevicesControllerUpdateDeviceConfigurationApiResponse =
    /** status 200 OK */ DeviceConfigurationDto;
export type DevicesControllerUpdateDeviceConfigurationApiArg = {
    deviceId: string;
    updateDeviceConfigurationRequest: UpdateDeviceConfigurationRequest;
};
export type ScannersControllerRetrieveDeviceConfigurationApiResponse =
    /** status 200 OK */ DeviceConfigurationDto;
export type ScannersControllerRetrieveDeviceConfigurationApiArg = {
    deviceId: string;
};
export type ScannersControllerRetrieveScannerApiResponse =
    /** status 200 OK */ ScannerDto;
export type ScannersControllerRetrieveScannerApiArg = {
    deviceId: string;
};
export type ScannersControllerRetrieveScannersApiResponse =
    /** status 200 OK */ ScannerDtoPagedList;
export type ScannersControllerRetrieveScannersApiArg = {
    pageNumber?: number;
    pageSize?: number;
    deviceId?: string;
    merchantId?: number;
    configurationProfileId?: number;
    scannerStatus?: ScannerStatus;
};
export type ScannersControllerImportScannersApiResponse = unknown;
export type ScannersControllerImportScannersApiArg = {
    body: {
        scannerImportCsv?: Blob;
    };
};
export type ScannersControllerCreateLinkRequestApiResponse =
    /** status 200 OK */ LinkRequestDto;
export type ScannersControllerCreateLinkRequestApiArg = {
    region?: BoddRegion;
    merchantId?: number;
};
export type ScannersControllerRetrieveLinkRequestApiResponse =
    /** status 200 OK */ LinkRequestDto;
export type ScannersControllerRetrieveLinkRequestApiArg = {
    merchantId: number;
    code: string;
};
export type ScannersControllerUnlinkScannerApiResponse =
    /** status 200 OK */ UnlinkScannerResult;
export type ScannersControllerUnlinkScannerApiArg = {
    deviceId: string;
};
export type ScannersControllerApproveQualityControlApiResponse =
    /** status 200 OK */ RegistrationResult;
export type ScannersControllerApproveQualityControlApiArg = {
    deviceId: string;
};
export type ScannersControllerDeclineQualityControlApiResponse =
    /** status 200 OK */ RegistrationResult;
export type ScannersControllerDeclineQualityControlApiArg = {
    deviceId: string;
};
export type ScannersControllerCancelActivationApiResponse = unknown;
export type ScannersControllerCancelActivationApiArg = {
    deviceId: string;
    activationId?: string;
};
export type ScannersControllerCreateManualDeviceConfigurationAuditEntryApiResponse =
    unknown;
export type ScannersControllerCreateManualDeviceConfigurationAuditEntryApiArg =
    {
        deviceId: string;
        createManualAuditEntryRequest: CreateManualAuditEntryRequest;
    };
export type ScannersControllerRetrieveDeviceConfigurationAuditApiResponse =
    /** status 200 OK */ DeviceConfigurationAuditItemDtoPagedList;
export type ScannersControllerRetrieveDeviceConfigurationAuditApiArg = {
    deviceId: string;
    eventTypes?: string;
    pageNumber?: number;
    pageSize?: number;
};
export type ScannersControllerCreateScannerDefectApiResponse =
    /** status 200 OK */ number;
export type ScannersControllerCreateScannerDefectApiArg = {
    deviceId: string;
    createScannerDefectRequest: CreateScannerDefectRequest;
};
export type ScannersControllerRetrieveScannerDefectsApiResponse =
    /** status 200 OK */ ScannerDefectDtoPagedList;
export type ScannersControllerRetrieveScannerDefectsApiArg = {
    deviceId: string;
    status?: string;
    pageNumber?: number;
    pageSize?: number;
};
export type ScannersControllerCloseScannerDefectApiResponse = unknown;
export type ScannersControllerCloseScannerDefectApiArg = {
    deviceId: string;
    defectId: number;
};
export type ScannersControllerReopenScannerDefectApiResponse = unknown;
export type ScannersControllerReopenScannerDefectApiArg = {
    deviceId: string;
    defectId: number;
};
export type AccessTokenResponse = {
    access_token?: string | null;
    token_type?: string | null;
    expires_in?: number;
    scope?: string | null;
};
export type QrInputConfigurationDto = {
    signingKey?: string | null;
    version?: number;
    fields?: string[] | null;
};
export type FitSelectionOption = "Male" | "Female" | "RegularFit" | "SlimFit";
export type ScanType =
    | "BodyScan"
    | "FootScan"
    | "WellnessScan"
    | "HandScan"
    | "HeadScan"
    | "HealthScan"
    | "MotionScan"
    | "BodyCompositionScan";
export type InstructionsType = "Default" | "Brief" | "Modest";
export type ExperienceOptionsDto = {
    theme?: string | null;
    completionMessage?: string | null;
    scanCompletedMessage?: string | null;
    identifierName?: string | null;
    quickResponseUrl?: string | null;
    qrInstructions?: string | null;
    quickResponseInstructions?: string | null;
    handleInstructionsEnabled?: boolean;
    subjectIdentifierEnabled?: boolean;
    qrInputEnabled?: boolean;
    qrInputConfiguration?: QrInputConfigurationDto;
    displayModelDuringUpload?: boolean;
    displayPreviewAfterScan?: boolean;
    fitPreferenceCaptureEnabled?: boolean;
    userScanTypeSelectionEnabled?: boolean;
    fitSelectionOptions?: FitSelectionOption[] | null;
    mandatoryScanTypes?: ScanType[] | null;
    instructionsType?: InstructionsType;
    scanReviewEnabled?: boolean;
};
export type ScanResultExportFormats = "Csv" | "Json";
export type ScanResultExportDataTypes =
    "Measurements" | "SizeMatch" | "MeasurementsAndSizeMatch";
export type ScanResultExportConfigDto = {
    merchantAwsAccountId?: string | null;
    assumeRoleArn?: string | null;
    assumeRoleExternalId?: string | null;
    dataFormat?: ScanResultExportFormats;
    dataTypes?: ScanResultExportDataTypes;
};
export type ConfigurationProfileDto = {
    id?: number;
    name?: string | null;
    merchantId?: number;
    userGroupId?: number;
    experienceOptions?: ExperienceOptionsDto;
    enabledScanTypes?: ScanType[] | null;
    permittedScanTypes?: ScanType[] | null;
    scanRetentionDays?: number;
    defaultIntegration?: string | null;
    ingressProfile?: string | null;
    scannerFeatureOverrides?: {
        [key: string]: string;
    } | null;
    scanResultExportConfig?: ScanResultExportConfigDto;
    analyticsTags?: {
        [key: string]: string;
    } | null;
};
export type ConfigurationProfileDtoPagedList = {
    items?: ConfigurationProfileDto[] | null;
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
};
export type ScannerStatus =
    | "AwaitRegistration"
    | "AwaitQualityControlScanApproval"
    | "QualityControlScanRejected"
    | "AwaitDiagnostics"
    | "AwaitCustomerQualityControlScan"
    | "Inactive"
    | "RequiresCredentials"
    | "Ready";
export type RegisterIotScannerResult = {
    scannerStatus?: ScannerStatus;
    merchantId?: number;
    thingName?: string | null;
    certificatePem?: string | null;
    privateKeyPem?: string | null;
};
export type CredentialRegistrationResult = {
    scannerStatus?: ScannerStatus;
    merchantId?: number;
    clientId?: string | null;
    clientSecret?: string | null;
    systemsManagerId?: string | null;
    systemsManagerCode?: string | null;
};
export type BoddRegion = "Unknown" | "AU" | "US" | "USWEST" | "EU" | "UK";
export type ConfigurationProfileSummaryDto = {
    id?: number;
    name?: string | null;
};
export type ScannerDto = {
    id?: number;
    name?: string | null;
    deviceId?: string | null;
    modelCode?: string | null;
    merchantId?: number;
    merchantName?: string | null;
    region?: BoddRegion;
    pendingSystemsManagerId?: string | null;
    certificateThumbprint?: string | null;
    regionApiBase?: string | null;
    scannerStatus?: ScannerStatus;
    openDefectCount?: number | null;
    configurationProfiles?: ConfigurationProfileSummaryDto[] | null;
    boddPin?: string | null;
    merchantPin?: string | null;
    locationId?: number | null;
    locationName?: string | null;
};
export type ScannerSettingsDto = {
    deviceId?: string | null;
    name?: string | null;
    assignedConfigurationProfiles?: number[] | null;
    boddPin?: string | null;
    merchantPin?: string | null;
};
export type AwsActivationDetailsDto = {
    systemsManagerId?: string | null;
    systemsManagerCode?: string | null;
};
export type DeviceConfigurationComponentType =
    "License" | "Hardware" | "Software";
export type ComponentDto = {
    identifier?: string | null;
    type?: DeviceConfigurationComponentType;
    metadata?: {
        [key: string]: string | null;
    } | null;
};
export type DeviceConfigurationDto = {
    deviceId?: string | null;
    components?: ComponentDto[] | null;
};
export type MetadataRequest = {
    key?: string | null;
    value?: string | null;
};
export type ComponentRequest = {
    id?: string | null;
    type?: DeviceConfigurationComponentType;
    metadata?: MetadataRequest[] | null;
};
export type UpdateDeviceConfigurationRequest = {
    components?: ComponentRequest[] | null;
};
export type ScannerDtoPagedList = {
    items?: ScannerDto[] | null;
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
};
export type LinkRequestDto = {
    code?: string | null;
    linkedScanner?: string | null;
};
export type UnlinkScannerResult = {
    deviceId?: string | null;
    merchantId?: number;
};
export type RegistrationResult = {
    scannerStatus?: ScannerStatus;
    merchantId?: number;
};
export type CreateManualAuditEntryRequest = {
    description?: string | null;
    componentName?: string | null;
};
export type ConfigurationEventType =
    | "ConfigurationCreated"
    | "ComponentAdded"
    | "ComponentUpdated"
    | "ComponentRemoved"
    | "ManualEntry";
export type DeviceConfigurationAuditItemDto = {
    id?: number;
    eventType?: ConfigurationEventType;
    componentName?: string | null;
    key?: string | null;
    description?: string | null;
    created?: string;
    createdBy?: string | null;
};
export type DeviceConfigurationAuditItemDtoPagedList = {
    items?: DeviceConfigurationAuditItemDto[] | null;
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
};
export type CreateScannerDefectRequest = {
    description?: string | null;
    componentName?: string | null;
};
export type DefectStatus = "Open" | "Closed";
export type ScannerDefectDto = {
    id?: number;
    description?: string | null;
    componentName?: string | null;
    status?: DefectStatus;
    created?: string;
    createdBy?: string | null;
};
export type ScannerDefectDtoPagedList = {
    items?: ScannerDefectDto[] | null;
    pageNumber?: number;
    totalPages?: number;
    totalCount?: number;
};
export const {
    useAuthControllerIssueTokenMutation,
    useConfigurationProfilesControllerRetrieveScannerProfilesQuery,
    useConfigurationProfilesControllerGetDefaultScannerProfileQuery,
    useConfigurationProfilesControllerRetrieveScannerProfileQuery,
    useConfigurationProfilesControllerUpdateScannerProfileMutation,
    useConfigurationProfilesControllerDeleteScannerProfileMutation,
    useConfigurationProfilesControllerUpdateScannerProfileAnalyticsTagsMutation,
    useConfigurationProfilesControllerUpdateScannerProfileFeatureOverridesMutation,
    useDevicesControllerIotRegisterMutation,
    useDevicesControllerQuickRegisterMutation,
    useScannersControllerUpdateScannerConfigurationMutation,
    useDevicesControllerCreateAwsActivationMutation,
    useDevicesControllerConfirmAwsActivationMutation,
    useDevicesControllerUpdateDeviceConfigurationMutation,
    useScannersControllerRetrieveDeviceConfigurationQuery,
    useScannersControllerRetrieveScannerQuery,
    useScannersControllerRetrieveScannersQuery,
    useScannersControllerImportScannersMutation,
    useScannersControllerCreateLinkRequestMutation,
    useScannersControllerRetrieveLinkRequestQuery,
    useScannersControllerUnlinkScannerMutation,
    useScannersControllerApproveQualityControlMutation,
    useScannersControllerDeclineQualityControlMutation,
    useScannersControllerCancelActivationMutation,
    useScannersControllerCreateManualDeviceConfigurationAuditEntryMutation,
    useScannersControllerRetrieveDeviceConfigurationAuditQuery,
    useScannersControllerCreateScannerDefectMutation,
    useScannersControllerRetrieveScannerDefectsQuery,
    useScannersControllerCloseScannerDefectMutation,
    useScannersControllerReopenScannerDefectMutation,
} = injectedRtkApi;
